module.exports = __webpack_public_path__ + "img/40_69_003_190.3916016a.jpg";